var inlineWinners = {
    init: function( id ) {

        var width_latest = $( window ).width( );

        var target = id + ' .win-item';

        $slider = $( id + ' .winners-grid-carousel' );

        $slider.on( 'initialized.owl.carousel', function( event ) {
            equalizeHeight( target );
        } );
        $slider.owlCarousel( {
            responsiveClass: true,
            nav: false,
            lazyLoad: true,
            margin: 30,
            responsive: {
                0: {
                    items: 1,
                    margin: 15,
                    loop: ( $( id + ' .winners-grid-carousel .win-item' ).length > 1 ) ? true : false,
                    pullDrag: ( $( id + ' .winners-grid-carousel .win-item' ).length > 1 ) ? true : false,
                    mouseDrag: ( $( id + ' .winners-grid-carousel .win-item' ).length > 1 ) ? true : false,
                    touchDrag: ( $( id + ' .winners-grid-carousel .win-item' ).length > 1 ) ? true : false,
                },

                576: {
                    items: 2,
                    margin: 15,
                    loop: ( $( id + ' .winners-grid-carousel .win-item' ).length > 2 ) ? true : false,
                    pullDrag: ( $( id + ' .winners-grid-carousel .win-item' ).length > 2 ) ? true : false,
                    mouseDrag: ( $( id + ' .winners-grid-carousel .win-item' ).length > 2 ) ? true : false,
                    touchDrag: ( $( id + ' .winners-grid-carousel .win-item' ).length > 2 ) ? true : false,
                },

                992: {
                    items: 3,
                    loop: ( $( id + ' .winners-grid-carousel .win-item' ).length > 3 ) ? true : false,
                    pullDrag: ( $( id + ' .winners-grid-carousel .win-item' ).length > 3 ) ? true : false,
                    mouseDrag: ( $( id + ' .winners-grid-carousel .win-item' ).length > 3 ) ? true : false,
                    touchDrag: ( $( id + ' .winners-grid-carousel .win-item' ).length > 3 ) ? true : false,
                },

                1400: {
                    items: 4,
                    loop: ( $( id + ' .winners-grid-carousel .win-item' ).length > 4 ) ? true : false,
                    pullDrag: ( $( id + ' .winners-grid-carousel .win-item' ).length > 4 ) ? true : false,
                    mouseDrag: ( $( id + ' .winners-grid-carousel .win-item' ).length > 4 ) ? true : false,
                    touchDrag: ( $( id + ' .winners-grid-carousel .win-item' ).length > 4 ) ? true : false
                }
            }
        } );


        $( window ).resize( function( ) {
            if ( $( window ).width( ) == width_latest ) return;
            width_latest = $( window ).width( );
            var rtime = new Date( );
            if ( timeout === false ) {
                timeout = true;
                resizedeltaFunction( target );

            }
        } );
    }
}


var winnersList = {
    init: function( ) {

        jQuery( document ).ready( function( $ ) {
            var timelineBlocks = $( '.cd-timeline-block' ),
                offset = 0.8;

            //hide timeline blocks which are outside the viewport
            hideBlocks( timelineBlocks, offset );

            //on scolling, show/animate timeline blocks when enter the viewport
            $( window ).on( 'scroll', function( ) {
                ( !window.requestAnimationFrame ) ?
                setTimeout( function( ) {
                    showBlocks( timelineBlocks, offset );
                }, 100 ): window.requestAnimationFrame( function( ) {
                    showBlocks( timelineBlocks, offset );
                } );
            } );

            function hideBlocks( blocks, offset ) {
                blocks.each( function( ) {
                    ( $( this ).offset( ).top > $( window ).scrollTop( ) + $( window ).height( ) * offset ) && $( this ).find( '.cd-timeline-img, .cd-timeline-content' ).addClass( 'is-hidden' );
                } );
            }

            function showBlocks( blocks, offset ) {
                blocks.each( function( ) {
                    ( $( this ).offset( ).top <= $( window ).scrollTop( ) + $( window ).height( ) * offset && $( this ).find( '.cd-timeline-img' ).hasClass( 'is-hidden' ) ) && $( this ).find( '.cd-timeline-img, .cd-timeline-content' ).removeClass( 'is-hidden' ).addClass( 'bounce-in' );
                } );
            }
        } );

        if ( $( '#view-more' ).length > 0 ) {
            var waypoint = new Waypoint( {
                element: $( '#view-more' ),
                handler: function( direction ) {

                    if ( $( '#view-more' ).length > 0 && $( '#view-more' ).offset( ).top > Waypoint.viewportHeight( ) ) {
                        $( '#view-more' ).trigger( 'click' );
                    }
                },
                offset: 'bottom-in-view'
            } );

            setTimeout( function( ) {
                Waypoint.refreshAll( );
            }, 1000 );
        }
    }
}